/*
***
  Static Variables
***
*/
import moment from "moment";
import {
  LuMessageSquareDot,
  LuMessageSquareMore,
  LuMessageSquareShare,
  LuMessageSquareText,
  LuMessageSquareWarning,
  LuMessageSquareX,
  LuStore,
} from "react-icons/lu";
import { TiShoppingCart } from "react-icons/ti";
import { SiGooglecalendar } from "react-icons/si";
import { RiCalendarScheduleFill } from "react-icons/ri";
import { IoMdEyeOff, IoMdChatboxes } from "react-icons/io";
import secureLocalStorage from "react-secure-storage";
import {
  BiSolidMessage,
  BiSolidMessageCheck,
  BiSolidMessageDetail,
  BiSolidMessageDots,
  BiSolidMessageError,
  BiSolidMessageX,
} from "react-icons/bi";
import {
  Briefcase,
  Camera,
  CheckCircle,
  Circle,
  Clock,
  Compass,
  FileText,
  Filter,
  Folder,
  Grid,
  Headphones,
  HelpCircle,
  Image,
  Info,
  Layout,
  List,
  MessageCircle,
  MessageSquare,
  Music,
  PauseCircle,
  RefreshCw,
  ShoppingCart,
  User,
  Video,
  Zap,
} from "react-feather";
import { HiOutlineExternalLink } from "react-icons/hi";
import { MdLocalPhone, MdReply } from "react-icons/md";
import { IoCopyOutline } from "react-icons/io5";
import { FaDotCircle } from "react-icons/fa";

const user = JSON.parse(secureLocalStorage.getItem("userData"));
const currentWabaData = secureLocalStorage.getItem("currentWabaData");
const currentDeviceNumber = secureLocalStorage.getItem("currentWabaPhoneNo");

export const profileTab = [
  { name: "Personal Info", value: "1" },
  { name: "Change Password", value: "2" },
  { name: "Api Key", value: "3" },
];

export const customerType = [
  { value: 0, label: "Personal" },
  { value: 1, label: "Business" },
];

export const defaultChatCounters = {
  pending: "",
  assigned: "",
  unassigned: "",
  resolved: "",
  unresolved: "",
  pendingDevice: "",
  unresolvedDevice: "",
};

// Default Table Records For Campaign
export const defaultTableRecords = [
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
  {
    name: "",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    var7: "",
    var8: "",
    var9: "",
    var10: "",
  },
];

// Default User Status list
export const userStatusList = [
  { value: -1, label: "All" },
  { value: 1, label: "Active" },
  { value: 2, label: "Inactive" },
  { value: 3, label: "Low Credit" },
  { value: 4, label: "New Register" },
];

// Row per Page options for pagination
export const rowPerPageOptions = [10, 25, 50, 75, 100, 500, 1000];

// Field value not accepted
export const IsNotValue = [
  null,
  "null",
  undefined,
  "undefined",
  "",
  "<p></p>\n",
  "Invalid Date",
  "Invalid date",
];

// Default Campaign Filter Value
export const campaignFilterValue = {
  c_status: -1,
  searchValue: "",
  s_date: "",
  e_date: "",
  is_schedule: 0,
};

// Default BroadCast Filter Value
export const broadCastFilterValue = {
  searchValue: "",
  s_date: "",
  e_date: "",
  is_schedule: 0,
};

// Default Date Range Filter
export const dateValue = [
  {
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  },
];

// Customer CSV Download Format Columns
export const exportCustomerCsvColumns = [
  { label: "Customer Name", key: "c_name" },
  { label: "Customer Number", key: "c_number" },
  { label: "Description", key: "c_description" },
];

// Default Campaign Status Value
export const campaignStatus = [
  { value: 0, label: "New" },
  { value: 1, label: "Processing" },
  { value: 2, label: "Completed" },
  { value: 3, label: "Failed" },
  { value: 4, label: "Pending" },
];

// Default Campaign Data
export const campaignData = {
  message: "",
  media: [],
  schedule: null,
  countryCode: "",
  delay: 0,
  device_token_array: [],
  is_spin_mode: 0,
  spin_after: 0,
  campaign_name: "",
};

export const defaultFilteredData = {
  s_date: moment(
    new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)
  ).format("YYYY-MM-DD"),
  e_date: moment(new Date()).format("YYYY-MM-DD"),
};

export const initialState = {
  message: "",
  delay: 0,
  media_url: "",
  media_id: "",
  caption: "",
  file_name: "",
  schedule: "",
  numbers: "",
  device_token: "",
};

export const DateValue = [
  {
    startDate: new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
    endDate: new Date(),
    key: "selection",
  },
];

export const defaultScheduleFilterValue = {
  c_status: -1,
  searchValue: "",
  s_date: "",
  e_date: "",
  is_schedule: 0,
};

export const statusOptions = [
  { value: 0, label: "New" },
  { value: 1, label: "In Queue" },
  { value: 2, label: "Completed" },
  { value: 3, label: "Failed" },
  { value: 4, label: "Pending" },
];

export const userStatusOptions = [
  { value: 1, label: "Active" },
  { value: 2, label: "Inactive" },
  { value: 3, label: "Low Credit" },
  { value: 4, label: "New Register" },
];

export const templateNavOptions = [
  { value: 0, title: "All", icon: <RefreshCw size={16} />, key: "ALL_COUNT" },
  {
    value: 1,
    title: "Approved",
    icon: <CheckCircle size={16} />,
    key: "APPROVED",
  },
  { value: 2, title: "Pending", icon: <Clock size={16} />, key: "PENDING" },
  {
    value: 3,
    title: "Rejected",
    icon: <Compass size={16} />,
    key: "REJECTED",
  },
  {
    value: 4,
    title: "Paused",
    icon: <PauseCircle size={16} />,
    key: "PAUSED",
  },
];

export const STATUS_COLOR = {
  all: "primary",
  approved: "success",
  pending: "warning",
  rejected: "danger",
  paused: "secondary",
};

export const StaffStatus = [
  { value: 0, label: "Active" },
  { value: 1, label: "Inactive" },
];

export const urlRegex = /(https?:\/\/[^\s]+)/g;

export const headers = [
  { label: "Name", key: "name" },
  { label: "Number", key: "number" },
  { label: "Device Name", key: "sendDevice_device_name" },
  { label: "Mobile Number", key: "sendDevice_mobile_no" },
  { label: "Status", key: "status" },
  { label: "Fail Reason", key: "fail_reason" },
  { label: "Date", key: "updated_at" },
];

export const messageListHeader = [
  { label: "Date & Time", key: "created_at" },
  { label: "Number", key: "number" },
  { label: "Message", key: "message" },
  { label: "Credit Use", key: "credit_use" },
  { label: "Status", key: "report_status" },
  { label: "Reason", key: "fail_reason" },
  { label: "Schedule", key: "schedule" },
  { label: "Message Send", key: "wm_send_at" },
  { label: "Message Delivered", key: "wm_delivered_at" },
  { label: "Message Read", key: "wm_read_at" },
];

export const mediaTypeList = [
  { value: 1, label: "Image" },
  { value: 2, label: "Audio" },
  { value: 3, label: "Video" },
  { value: 4, label: "File" },
];

export const userExportHeader = [
  { label: "Name", key: "name" },
  { label: "Number", key: "mobile" },
  { label: "Balance", key: "wallet" },
  { label: "Status", key: "user_status" },
  { label: "Registration Date", key: "created_at" },
];

export const messageTypeList = [
  { value: 1, label: "Text" },
  { value: 2, label: "Image" },
  { value: 3, label: "Video" },
];

export const defaultIntents = {
  defaultMessageSwitch: false,
  defaultMessageType: 1,
  defaultMessage: "",
  defaultMediaUrl: "",
  orderMessageSwitch: false,
  orderMessageType: 1,
  orderMessage: "",
  orderMediaUrl: "",
};

export const intentsPart = [
  {
    title: "Default Message",
    sub_title:
      "This message will trigger when the user not respond as per the flow",
    switchField: "defaultMessageSwitch",
    selectType: "defaultMessageType",
    mediaUrl: "defaultMediaUrl",
    message: "defaultMessage",
  },
  {
    title: "Order Message",
    sub_title:
      "This message will trigger when the user place order with checkout link",
    switchField: "orderMessageSwitch",
    selectType: "orderMessageType",
    mediaUrl: "orderMediaUrl",
    message: "orderMessage",
  },
];
export const documentTypes = [
  "plain", // for simple text file
  "pdf", // for pdf file allow
  "csv", // for csv file allow
  "vnd.ms-excel", // for xls file allow
  "vnd.openxmlformats-officedocument.spreadsheetml.sheet", // for xlsx file allow
  "vnd.ms-powerpoint", // for ppt file allow
  "vnd.openxmlformats-officedocument.presentationml.presentation", // for pptx file allow
  "msword", // for doc file allow
  "vnd.openxmlformats-officedocument.wordprocessingml.document", // for docx file allow
];

export const wordFileType = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const sheetFileType = [
  "text/csv",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

export const pptFileType = [
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

export const videoType = ["mp4, 3gp"];

export const audioType = ["mp3", "ogg", "mpeg"];

export const mediaSelectDropdown = [
  { type: 1, label: "Document", icon: <FileText size={16} /> },
  { type: 2, label: "Photo", icon: <Camera size={16} /> },
  { type: 3, label: "Video", icon: <Video size={16} /> },
  { type: 4, label: "Audio", icon: <Music size={16} /> },
  { type: 5, label: "Template", icon: <List size={16} /> },
];

export const documentSupportedMessage =
  "Only .txt, .xls, .xlsx, .doc, .docx, .ppt, .pptx, .pdf and .csv Document file Supported.";
export const videoSupportedMessage = "Only .mp4 and .3gp Video file Supported.";
export const audioSupportedMessage = "Only .mp3 and .ogg Audio file Supported.";

export const chatTab = [
  {
    value: 1,
    icon: <FaDotCircle size="12" className="me-0" />,
    title: "All",
    counter_field: "all_counter",
  },
  {
    value: 2,
    icon: <IoMdEyeOff size="14" className="me-0" />,
    title: "Unread",
    counter_field: "pending_counter",
  },
  {
    value: 3,
    icon: <IoMdChatboxes size="14" className="me-0" />,
    title: "My Chat",
    counter_field: "my_chat_counter",
  },
];

export const chatFilterType = [
  // { label: "All", value: -1 },
  { label: "UnResolved", value: 0 },
  { label: "Resolved", value: 1 },
];

export const totalTabs = 3;

export const dynamicFieldTypeList = [
  { label: "Text Input", value: "text" },
  { label: "TextArea Input", value: "textarea" },
  { label: "Dropdown Input", value: "dropdown" },
  { label: "Radio Input", value: "radio" },
  { label: "Checkbox", value: "checkbox" },
  { label: "Date Input", value: "date" },
  { label: "Time Input", value: "time" },
];

export const defaultCustomerHeaders = [
  { label: "FName", key: "first_name" },
  { label: "LName", key: "last_name" },
  { label: "Phone", key: "phone" },
  { label: "Email", key: "email" },
  { label: "Customer Type", key: "type" },
  { label: "DOB", key: "dob" },
];

export const packageTypeOption = [
  { label: "Message Package", value: 0 },
  { label: "Device Package", value: 1 },
  { label: "Storage Package", value: 2 },
];

export const wabaPackageCategory = [
  { label: "Basic", value: 1 },
  { label: "Premium", value: 2 },
  { label: "Enterprice", value: 3 },
];

export const ExpandableTableVariableForWabaPackage = [
  { label: "Multi Agent Live Chat", field: "multi_agent_live_chat" },
  { label: "Customer Management", field: "customer_management" },
  { label: "Auto reply & Chatbot", field: "auto_reply_messages" },
  { label: "Unlimited Customer Tags", field: "unlimited_customer_tags" },
  { label: "Custom Attributes", field: "custom_attributes" },
  { label: "File Manager", field: "files_manager" },
];

export const ExpandableTableCountVariableForWabaPackage = [
  { label: "No. of Meta Account", field: "no_of_meta_Account" },
  { label: "No. of Agents", field: "no_of_agents" },
  { label: "No. of Flow Builder", field: "no_of_flow_builder" },
  { label: "Storage in MB", field: "storage" },
  // { label: "No. of Campaign", field: "no_of_campaign" },
];

export const EMAIL_VALIDATION_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const renderCounter = [
  { label: "Total User", field: "Total_user", class: "" },
  { label: "Active User", field: "Active_user", class: "bg-light-success" },
  {
    label: "Deactivate User",
    field: "DeActive_user",
    class: "bg-light-danger",
  },
];

export const defaultCustomerValues = {
  store_id: user?.u_type == 1 ? user?.u_id : user?.parent_u_id,
  u_waba_id: currentWabaData?.u_waba_id,
  waba_device_id: currentDeviceNumber?.waba_device_id,
  c_fname: "",
  c_lname: "",
  c_email: "",
  c_number: "",
  c_type: 0,
  c_dob: null,
  labels: [],
  note: "",
  custom_fields: [],
  fieldType: [],
};

export const checkBoxList = [
  { label: "Template", field: "p_template", value: false },
  { label: "Customer", field: "p_customer", value: false },
  { label: "Broadcast", field: "p_broadcast", value: false },
  { label: "Customer Label", field: "p_customer_label", value: false },
  { label: "Quick Reply", field: "p_quick_reply", value: false },
  { label: "Media", field: "p_media", value: false },
  // { label: "Catalogue", field: "p_catalogue", value: false },
  // { label: "General Settings", field: "p_general_settings", value: false },
  { label: "Whatsapp Chat Bot", field: "p_chat_bot", value: false },
  { label: "Flow Form", field: "p_flow_form", value: false },
];

export const NonMetaModuleSwitchList = [
  { label: "Chat", field: "n_m_p_chat", value: false },
  { label: "Device", field: "n_m_p_device", value: false },
  { label: "Contact", field: "n_m_p_contact", value: false },
  { label: "Campaign", field: "n_m_p_campaign", value: false },
  { label: "Media", field: "n_m_p_media", value: false },
];

export const imageFileAccept = ["image/jpg", "image/jpeg", "image/png"];

export const videoFileAccept = ["video/mp4"];

export const documentFileAccept = ["application/pdf"];

export const variableRegex = /\{{(.*?)\}}/g;

export const emojiRegex =
  /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F1E0}-\u{1F1FF}]|\u{200D}|\u{FE0F}/gu;

export const defaultTemplate = {
  name: "",
  category: "",
  language: "",
  u_waba_id: "",
  template_type: 1,
  body: "",
  footer: "",
  body_variables: [],
  header_variable: [],
  quick_button_counter: 10,
  url_button_counter: 2,
  phone_number_button_counter: 1,
  copy_code_button_counter: 1,
  header_type: 0,
  buttonCount: 2,
  buttonArray: [],
  header_url: "",
  body_show_emoji: false,
  show_header_url_input: false,
  limited_time_offer_text: "",
  has_expiration: false,
  auth_variable: "",
  add_security_recommendation: false,
  code_expiration_minutes: "",
  headerMedia: { fileName: "", file: null },
  carousel_card: [
    {
      url: "",
      show_url_input: false,
      carousel_body: "",
      carousel_variable: [],
      uploadMedia: { fileName: "", file: null },
      buttonArray: [],
      show_emoji: false,
    },
  ],
};

export const headerButtonList = [
  { value: 0, label: "None" },
  { value: 1, label: "Text" },
  { value: 2, label: "Image" },
  { value: 3, label: "Video" },
  { value: 4, label: "Document" },
  { value: 5, label: "Location" },
];

export const templateType = [
  { value: 1, label: "Normal Template" },
  { value: 2, label: "Carousel Template" },
  { value: 3, label: "Limited-Time Offer Template" },
  { value: 4, label: "Catalog Template" },
  { value: 5, label: "Single-Product Message Templates" },
  { value: 6, label: "Multi-Product Message Templates" },
  { value: 7, label: "Flow Template" },
];

export const carouselCardHeaderButton = [
  { value: 2, label: "Image" },
  { value: 3, label: "Video" },
];

export const cardButtonType = [
  {
    value: "QUICK_REPLY",
    label: "Custom Button",
    field: "quick_button_counter",
    icon: <MdReply size="17" />,
  },
  {
    value: "URL",
    label: "Visit Website",
    field: "url_button_counter",
    icon: <HiOutlineExternalLink size="17" />,
  },
  {
    value: "PHONE_NUMBER",
    label: "Call Phone Number",
    field: "phone_number_button_counter",
    icon: <MdLocalPhone size="17" />,
  },
  {
    value: "COPY_CODE",
    label: "Copy Code",
    field: "copy_code_button_counter",
    icon: <IoCopyOutline size="17" />,
  },
];

export const resetTemplate = {
  body: "",
  body_variables: [],
  header_variable: [],
  quick_button_counter: 10,
  url_button_counter: 2,
  phone_number_button_counter: 1,
  copy_code_button_counter: 1,
  header_type: 0,
  buttonCount: 2,
  header_url: "",
  body_show_emoji: false,
  buttonArray: [],
  auth_variable: "",
  has_expiration: false,
  limited_time_offer_text: "",
  show_header_url_input: false,
  add_security_recommendation: false,
  code_expiration_minutes: "",
  uploadMedia: { fileName: "", file: null },
  carousel_card: [
    {
      url: "",
      show_url_input: false,
      carousel_body: "",
      carousel_variable: [],
      uploadMedia: { fileName: "", file: null },
      buttonArray: [],
      show_emoji: false,
    },
  ],
};

export const defaultSelectTemplateValue = {
  template_id: "",
  body: "",
  body_variables: [],
  header_type: 2,
  carousel_card: [
    {
      url: "",
      carousel_body: "",
      carousel_variable: [],
    },
  ],
};

export const headerData = {
  variableType: "header_variable",
  field: "header",
  fieldType: "header",
};

export const bodyData = {
  variableType: "body_variables",
  field: "body",
  fieldType: "body",
};

export const defaultBroadcastValue = {
  broadcast_name: "",
  template: {},
  templateData: {},
  waba_t_id: "",
  waba_device_id: "",
  schedule_campaign: false,
  schedule: null,
};

export const broadcastSteps = [
  {
    id: "broadcast",
    title: "Broadcast",
    subtitle: "Provide Broadcast Details.",
  },
  {
    id: "define_audience",
    title: "Define Audience",
    subtitle: "Provide Audience Details.",
  },
  {
    id: "create_message",
    title: "Create Message",
    subtitle: "Provide Message Details.",
  },
  {
    id: "test_campaign",
    title: "Test Broadcast",
    subtitle: "Test Broadcast ",
  },
  {
    id: "config_campaign",
    title: "Config Campaign",
    subtitle: "Provide Config Details",
  },
];

export const deviceErrorMessage =
  "You have Reached your device limit, please Go to Dashboard and reconnect Device";

export const curlTabs = [
  { label: "cURL", value: 1 },
  { label: "Node Js - Axios", value: 2 },
  { label: "PHP", value: 3 },
];

export const toolBarList = [
  {
    title: "Message Types",
    menu: [
      {
        type: "text_button",
        label: "Text Buttons",
        icon: <Layout size={16} color="green" />,
      },
      {
        type: "media_button",
        label: "Media Buttons",
        icon: <Image size={16} color="green" />,
      },
      {
        type: "list_msg",
        label: "List",
        icon: <List size={16} color="green" />,
      },
      {
        type: "catalogue_message",
        label: "Catalogue Message",
        icon: <LuStore size="16" color="green" />,
      },
      {
        type: "single_product",
        label: "Single Product",
        icon: <ShoppingCart size={16} color="green" />,
      },
      {
        type: "multi_product",
        label: "Multi Product",
        icon: <TiShoppingCart size="18" color="green" />,
      },
      {
        type: "template_button",
        label: "Template",
        icon: <Zap size={16} color="green" />,
      },
      {
        type: "custom_message",
        label: "Custom Message",
        icon: <MessageCircle size={16} color="green" />,
      },
    ],
  },
  {
    title: "Actions",
    menu: [
      {
        type: "request_button",
        label: "Request Intervention",
        icon: <User size={16} color="green" />,
      },
      {
        type: "information_button",
        label: "Information Rules",
        icon: <Info size={16} color="green" />,
      },
    ],
  },
  {
    title: "Input & CRM",
    menu: [
      {
        type: "question_box",
        label: "Question Box",
        icon: <HelpCircle size={16} color="green" />,
      },
      {
        type: "validator_box",
        label: "Validator Box",
        icon: <Filter size={16} color="green" />,
      },
      {
        type: "crm_action",
        label: "CRM Action",
        icon: <Briefcase size={16} color="green" />,
      },
    ],
  },
];

export const validatorOperatorList = [
  { label: "% Like %", value: "like_percent" },
  { label: "Like", value: "like" },
  { label: "Between", value: "between" },
  { label: "=", value: "=" },
  { label: ">=", value: ">=" },
  { label: "<=", value: "<=" },
  { label: "<", value: "<" },
  { label: ">", value: ">" },
  { label: "Custom", value: "custom" },
];

export const crmActionList = [
  { label: "Add Lead", value: "add_lead" },
  { label: "Update Lead", value: "update_lead" },
  { label: "Assign Staff", value: "assign_staff" },
  { label: "Add Label", value: "add_label" },
  { label: "Update Status", value: "update_status" },
];

export const metaPackageType = [
  { label: "Basic", value: "1" },
  { label: "Premium", value: "2" },
  { label: "Enterprice", value: "3" },
];

export const menuList = [
  {
    label: "All",
    filterValue: "",
    value: 0,
    icon: <Folder size={24} className="me-75" />,
  },
  {
    label: "Images",
    filterValue: "image",
    value: 1,
    icon: <Image size={24} className="me-75" />,
  },
  {
    label: "Videos",
    filterValue: "video",
    value: 0,
    icon: <Video size={24} className="me-75" />,
  },
  {
    label: "Audio",
    filterValue: "audio",
    value: 0,
    icon: <Headphones size={24} className="me-75" />,
  },
  {
    label: "Other",
    filterValue: "other",
    value: 0,
    icon: <Grid size={24} className="me-75" />,
  },
];

export const flowCategoryList = [
  { value: "SIGN_UP", label: "Sign Up", color: "#FF5733" }, // Add a color to each category
  { value: "SIGN_IN", label: "Sign In", color: "#33FF57" },
  {
    value: "APPOINTMENT_BOOKING",
    label: "Appointment Booking",
    color: "#3357FF",
  },
  { value: "LEAD_GENERATION", label: "Lead Generation", color: "#FF33A1" },
  { value: "CONTACT_US", label: "Contact Us", color: "#FFC300" },
  { value: "CUSTOMER_SUPPORT", label: "Customer Support", color: "#900C3F" },
  { value: "SURVEY", label: "Survey", color: "#C70039" },
  { value: "OTHER", label: "Other", color: "#000" },
];

export const defaultFlowFormData = {
  name: "",
  category: 1,
  u_waba_id: "",
  // language: "",
  template_type: 7,
  categories: [],
};

export const AddAnswerOptionList = [
  { label: "Text", value: "0" },
  { label: "Password", value: 1 },
  { label: "Email", value: 2 },
  { label: "Number", value: 3 },
  { label: "Passcode", value: 4 },
  { label: "Phone", value: 5 },
];

export const logoutDeviceChannel = [
  "REQUEST_TO_LOGOUT_DEVICE_SUCCESS",
  "REQUEST_TO_LOGOUT_CUSTOMER_CARE_DEVICE_SUCCESS",
];
export const deviceAddChannel = ["DEVICE_ADDED", "DEVICE_ADDED_CODE"];
export const customerCareChannel = [
  "CUSTOMER_CARE_DEVICE_ADDED",
  "CUSTOMER_CARE_DEVICE_ADDED_CODE",
];

export const websettingTabs = [
  { label: "General Settings", value: 1 },
  { label: "Invoice Settings", value: 2 },
];

export const contactExportHeader = [
  { label: "Contact Name", key: "f_name" },
  { label: "Contact Number", key: "c_number" },
  { label: "Message Sender Device", key: "device_name" },
  { label: "Campaign", key: "campaign_name" },
];

export const campaignAudianceType = [
  {
    label: "All Subscribed Audiences",
    description: "All Subscribed Audiences List",
    value: 0,
  },
  {
    label: "By Label Contacts",
    description: "Select Label wise Contacts List",
    value: 1,
  },
  {
    label: "From Campaign List",
    description: "Select Contacts from a Specific Campaign",
    value: 2,
  },
  {
    label: "Upload CSV",
    description: "Upload a CSV file with Contact List",
    value: 3,
  },
];
export const onlyLeadCapturePurchase =
  ([...IsNotValue, 0].includes(user?.waba_p_id) &&
    [...IsNotValue, 0].includes(user?.w_p_p_id) &&
    user?.lead_capture_p_p_id > 0) ||
  user?.only_purchase_lead_capture == 1;

export const showApiMessageTypes = [
  {
    value: 1,
    label: "Last 30 Days Messages",
    icon: SiGooglecalendar,
    description:
      "Here Display that messages which are sent in last 30 days with along with their details.",
  },
  {
    value: 2,
    label: "Messages Older Than 30 Days",
    icon: RiCalendarScheduleFill,
    description:
      "Here Display that messages which are sent before last 30 days with along with their details.",
  },
];

export const campaignReportCounterCards = [
  //

  {
    label: "Total",
    key: "total_message_count",
    icon: BiSolidMessageDetail,
    color: "secondary",
  },
  {
    label: "New",
    key: "new_count",
    icon: BiSolidMessage,
    color: "success",
  },
  {
    label: "Pending",
    key: "pending_count",
    icon: BiSolidMessageError,
    color: "warning",
  },
  {
    label: "Processing",
    key: "processing_count",
    icon: BiSolidMessageDots,
    color: "info",
  },
  {
    label: "Success",
    key: "completed_count",
    icon: BiSolidMessageCheck,
    color: "primary",
  },
  {
    label: "Failed",
    key: "failed_count",
    icon: BiSolidMessageX,
    color: "danger",
  },
];
